import React, { useState } from 'react';
import dayjs from 'dayjs';
import '../../style/Calendar.scss'; // Assure-toi que ce fichier existe

const daysOfWeek = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];

export default function Calendar({ onDateSelect, prizes }) {
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState(null);

  const startOfMonth = currentDate.startOf('month');
  const startDay = startOfMonth.day();
  const daysInMonth = currentDate.daysInMonth();

  const days = [];
  for (let i = 0; i < startDay; i++) {
    days.push(null);
  }
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(dayjs(currentDate).date(i));
  }

  const prevMonth = () => setCurrentDate(currentDate.subtract(1, 'month'));
  const nextMonth = () => setCurrentDate(currentDate.add(1, 'month'));

  const handleDateClick = (date) => {
    setSelectedDate(date);
    onDateSelect(date);
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={prevMonth}>&lt;</button>
        <h2>{currentDate.format('MMMM YYYY')}</h2>
        <button onClick={nextMonth}>&gt;</button>
      </div>

      <div className="calendar-grid">
        {daysOfWeek.map((day) => (
          <div key={day} className="calendar-day-name">{day}</div>
        ))}
        {days.map((date, index) => (
          <div
            key={index}
            className={`calendar-day ${date ? 'clickable' : 'empty'} ${
                selectedDate && date && selectedDate.isSame(date, 'day') ? 'selected' : ''
              }`}             
            onClick={() => date && handleDateClick(date)}
          >
            {date ? date.date() : ''}

            {prizes.map((prize, index) => {
              const distribution = prize.prizes_distribution.find((pd) => {
                  return isSameDay(new Date(pd.date), new Date(date));
                });

                if(!distribution) {
                  return null;
                }

                console.log("Distribution for prize", prize.label, "on date", date.format('YYYY-MM-DD'), distribution);
                  
                return (
                  <span style={{color: selectedDate && date && selectedDate.isSame(date, 'day') ? 'white' : distribution.qts > 0 ? 'green' : 'red'}} key={index}>
                    <div key={index} className="prize-distribution">
                      {prize.label} ({distribution.qts})
                    </div>
                  </span>
                );
              })}
          </div>
        ))}
      </div>
    </div>
  );
}


function isSameDay(d1, d2) {
  return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
  );
}